import React from 'react';

import TextInput from '../../../Forms/Components/TextInput';
import {isIntegerBetweenLengthRange} from '../../../Forms/Validation/rules';
import {InputHeading} from '../../../Forms/FormStyles/formStyles';

import BaseForm from './BaseForm';

class BankingForm extends React.Component {
    render() {
        return <BaseForm
            domRef={this.props.domRef}
            formId="banking"
            showHeader={this.props.showHeader}
            header="Byt betalsätt till autogiro"
            body="Det konto som anges måste vara ditt eget."
            onSubmit={this.props.onSubmit}
            onFormHeaderClick={ e => this.props.onFormHeaderClick() }
            termsAndConditionsUrl={this.props.termsAndConditionsUrl}
        >
            <div className="extend-student-insurance-teaser__content__section extend-student-insurance-teaser__content__section--columns">
                <div className="extend-student-insurance-teaser__content__section__column">
                    <InputHeading>Clearingnummer</InputHeading>
                    <TextInput
                        id="bankcode"
                        name="bankcode"
                        placeholder={"Ange clearingnummer"}
                        data-validation-error-message="Ange clearingnummer"
                        validations={[
                            isIntegerBetweenLengthRange(4,5)
                        ]}
                    />
                </div>
                <div className="extend-student-insurance-teaser__content__section__column">
                    <InputHeading>Kontonummer</InputHeading>
                    <TextInput
                        id="accountnumber"
                        name="accountnumber"
                        placeholder={"Ange kontonummer"}
                        data-validation-error-message="Ange kontonummer"
                        validations={[
                            isIntegerBetweenLengthRange(6,12)
                        ]}
                    />
                </div>
            </div>
        </BaseForm>;
    }
}

// state

export default BankingForm;